import styled from "@emotion/styled";
import { Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";

export const StyledCard = styled(motion(Flex))`
  border-radius: 10px;
`;
